import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { ForgotPasswordComponent } from 'app/main/module/auth/forgot-password/forgot-password.component';
import {SharedModule} from '../../common/shared.module';

const routes = [
    {
        path     : 'forgot-password',
        component: ForgotPasswordComponent
    }
];

@NgModule({
    declarations: [
        ForgotPasswordComponent
    ],
    imports     : [
        RouterModule.forChild(routes),
        SharedModule,
        FuseSharedModule,
    ]
})
export class ForgotPasswordModule
{
}
